import React, { useState, useContext } from 'react';
import { post } from '@utils/axios_api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { HeaderContext } from '@context/HeaderContext';
import { ScrollTop, HeaderNavi, Footer, MyPageLeftMenuStudent } from '@components';

// AuthContext에서 'passProfileCheck'를 가져오기
import { AuthContext } from '@context'; 

const MyPasswordStudentPage = () => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { setSubMenu } = useContext(HeaderContext);

  const { passProfileCheck } = useContext(AuthContext);

  // 페이지 로딩 시 "개인정보관리" 서브메뉴 설정
  React.useEffect(() => {
    setSubMenu("개인정보관리");
  }, [setSubMenu]);

  const handleCheck = async () => {
    try {
      await post('/reconfirm-password', { password });
      toast.success('비밀번호 확인 완료!');
      // 비번 통과했다는 기록
      passProfileCheck();

      navigate('/myLectures/myStudentProfile');
    } catch (error) {
      toast.error('비밀번호가 틀렸습니다. 다시 시도해주세요.');
    }
  };

  return (
    <>
      <ScrollTop />
      <main id="main" className="mainpage">
        <div>
          <div className="section main-contact">
            <HeaderNavi selectedCategory="개인정보관리" />
            <div className="sub-container">
              <div className="sub-layout">
                <MyPageLeftMenuStudent />

                {/* 본문 컨텐츠 */}
                <div className="sub-contact">
                  <h3 className="border-bt">개인정보관리 - 비밀번호 확인</h3>
                  <div id="tab01">
                    <div className="lineTop_tb01">
                      <table className="lineTop_tb">
                        <colgroup><col width="250px" /></colgroup>
                        <thead>
                          <tr><th>비밀번호 확인</th></tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <input
                                type="password"
                                className="inp-sel-sub"
                                placeholder="비밀번호를 입력하세요"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    handleCheck(); // Enter 키를 누르면 handleCheck 호출
                                  }
                                }}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button className="my-custombtn btn-customblue mt30" onClick={handleCheck}>확인</button>
                </div>
                {/* 본문 컨텐츠 끝 */}
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
};

export default MyPasswordStudentPage;